import useAutoTranslate from "./useAutoTranslate"

const T = ({ children }) => {
  const { translated, directionProps } = useAutoTranslate(children)

  return (
    <div
      dir={directionProps.dir} // Use the dir prop directly on the wrapper
      style={{
        direction: directionProps.direction,
        // You can keep additional styles here if needed
      }}
    >
      {translated}
    </div>
  )
}

export default T
